import { component, observable, computed } from 'knockout-decorators'
import { CartState } from '../state'

import { type Offer } from '@tixa/schema'

import source from './template.html?raw'

@component('cart-modal-content', source)
export class Cart {
  // Cart state
  private cartState: CartState = CartState.get()
  private readonly optionalCategories = ['newsletter']

  @observable public validated = false

  public setValidated() {
    this.validated = true
  }

  @computed get optionalOffers(): Offer[] {
    return this.cartState.offers.filter((offer) =>
      this.optionalCategories.includes(offer.category)
    )
  }

  @computed get hasOptionalOffers(): boolean {
    return this.optionalOffers.length > 0
  }
}
